<template>
  <!-- 厂商成套设备订单详情 -->
  <div class="detail">
    <div class="order-status">
      当前状态：
<!--        {{ statusName }}-->
        {{orderInfo.orderSatus == 0 ? '未确认提交': orderInfo.orderSatus == 1 ? '待厂商确认' : orderInfo.orderSatus == 2 ? '待平台签约'
        : orderInfo.orderSatus == 3 ? '待客户支付租金' : orderInfo.orderSatus == 24 ? '待厂商支付服务费'
            : orderInfo.orderSatus == 34 ? '待平台确认服务费': orderInfo.orderSatus == 5 ? '待厂商安装验收'
                : orderInfo.orderSatus == 6 ? '待客户用电完成' : orderInfo.orderSatus == 7 ? '已完成'
                    : orderInfo.orderSatus == 8 ? '已完成(已评价)' : orderInfo.orderSatus == 70 ? '中止订单' : '其他'}}
      <div class="">
        <el-button
          plain
          type="primary"
          size="medium"
          @click="compHandle()"
          v-if="status == 5"
          >安装验收完成
        </el-button>
        <el-button type="warning" size="medium" plain @click="contactService"
          >联系客服</el-button
        >
      </div>
    </div>
    <div class="detail-box" v-for="(item, index) in equList" :key="index">
      <div class="device-box flex-row">
        <div class="device-img">
          <img :src="imgUrl + item.pictureUrl" />
        </div>
        <div class="device-info">
          <p class="name">{{ item.title }}</p>
          <div class="price-box flex-row">
            <span>价格</span>
            <span class="price"
              >￥{{ item.duration_price }}/{{ orderPro.duration }}月</span
            >
          </div>
          <p class="tips">
            *价格说明<br />
            以上价格标注为参考价，具体价格您根据需求下单后待双方协商
          </p>
        </div>
        <div class="info">
          <div class="title">
            <p>设备信息</p>
          </div>
          <div class="info-intro">
            <div class="item">
              <label>提供人姓名</label> <span>{{ item.userName }}</span>
            </div>
            <div class="item">
              <label>设备类型</label> <span>{{ item.typeName }}</span>
            </div>
            <div class="item">
              <label>设备容量</label> <span>{{ item.volume }}</span>
            </div>
            <div class="item">
              <label>设备地点</label>
              <span>{{
                item.provinceName + item.cityName + item.countyName
              }}</span>
            </div>
            <div class="item">
              <label>输出电压</label> <span>{{ item.voltage }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="intro-box">
        <div class="title">配套线路：</div>
        <div class="service-plan flex-row">
          <div class="item">
            <label>架空线路：</label>
            <span>{{ item.priceGears && item.priceGears.jkxl }}元/档</span>
            <span v-if="item.dsbjkxl"> * {{ item.dsbjkxl }}</span>
          </div>
          <div class="item">
            <label>电缆线路：</label>
            <span>{{ item.priceGears && item.priceGears.dlxl }}元/米</span>
            <span v-if="item.dsbdlxl"> * {{ item.dsbdlxl }}</span>
          </div>
          <div class="item">
            <label>单杆：</label>
            <span>{{ item.priceGears && item.priceGears.dgxl }}元/个</span>
            <span v-if="item.dsbdgxl"> * {{ item.dsbdgxl }}</span>
          </div>
          <div class="" style="margin-left: 20px">
            标准档距：50米/档，现场勘查时不足50米按一档计；相关设备以及线路占地用户负责协调
          </div>
        </div>
      </div>
      <div class="change-parms-box" v-if="orderInfo.orderSatus == 1">
        <div class="item">
          <p>
            架空线路：<span
              >{{ item.priceGears && item.priceGears.jkxl }}元/档</span
            >
          </p>
          <el-input-number
            v-model="item.dsbjkxl"
            @change="getSimTotal"
            :min="0"
            :max="100"
            label="描述文字"
          >
          </el-input-number>
        </div>
        <div class="item">
          <p>
            电缆线路：<span
              >{{ item.priceGears && item.priceGears.dlxl }}元/米</span
            >
          </p>
          <el-input-number
            v-model="item.dsbdlxl"
            @change="getSimTotal"
            :min="0"
            :max="100"
            label="描述文字"
          >
          </el-input-number>
        </div>
        <div class="item">
          <p>
            单杆：<span
              >{{ item.priceGears && item.priceGears.dgxl }}元/个</span
            >
          </p>
          <el-input-number
            v-model="item.dsbdgxl"
            @change="getSimTotal"
            :min="0"
            :max="1"
            label="描述文字"
          >
          </el-input-number>
        </div>
      </div>
      <el-button
        type="info"
        size="medium"
        @click="changeBaodianD(item.id)"
        style="display: flex; justify-content: end; margin-top: 20px"
        v-if="orderInfo.orderSatus == 1 && orderInfo.serviceFeeRefund == 2"
        >确定设备
      </el-button>
    </div>
    <div class="userinfo">
      <div class="title">用户信息</div>
      <div class="user">
        <div class="name">{{ user.username }}</div>
        <ul>
            <li>
                <div class="key">工程名称：</div>
                <div class="value">{{ orderInfo.projectname }}</div>
            </li>
          <li>
            <div class="key">地址：</div>
            <div class="value">{{ orderInfo.userAddress }}</div>
          </li>
          <li>
            <div class="key">租赁期限：</div>
            <div class="value">{{ user.limit }}</div>
          </li>
          <li>
            <div class="key">开始时间：</div>
            <div class="value">{{ user.start |formatDate}}</div>
          </li>
          <li>
            <div class="key">结束时间：</div>
            <div class="value">{{ user.end |formatDate}}</div>
          </li>
<!--            <li>-->
<!--                <div class="key">平台签约时间：</div>-->
<!--                <div class="value">{{ orderInfo.qrhtTime }}</div>-->
<!--            </li>-->
        </ul>
      </div>
      <!-- 	<div class="renew">
				续费更新
				<li>
					<div class="key">租赁期限：</div>
					<div class="value">{{ renew.limit }}</div>
				</li>
				<li>
					<div class="key">开始时间：</div>
					<div class="value">{{ renew.start }}</div>
				</li>
				<li>
					<div class="key">结束时间：</div>
					<div class="value">{{ renew.end }}</div>
				</li>
			</div> -->
    </div>
<!--    <div class="file" v-show="status > 2">-->
<!--      <div class="title">附件合同签约</div>-->
<!--      <div class="hint">*已完成签约，可下载签约合同。</div>-->
<!--      <div class="contract">-->
<!--        <div class="cont">-->
<!--          <div class="img"><img src="../../assets/image/PDF.png" alt="" /></div>-->
<!--          <div class="right">-->
<!--            <div class="name">-->
<!--              {{ "成套设备租赁合同" }}-->
<!--              <span>(签约版)</span>-->
<!--            </div>-->
<!--            <div class="time">{{ orderInfo.qrhtTime }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="download">-->
<!--          <el-button type="warning" plain size="mini" @click="downloadFile"-->
<!--            >下载</el-button-->
<!--          >-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="order">
      <div class="title">
        订单信息
        <el-button plain size="mini" @click="checkOrder">查看往来账目</el-button>
      </div>
      <ul class="time-list">
        <li>
          <div class="key">订单编号：</div>
          <div class="value">{{ orderInfo.orderNo }}</div>
        </li>
        <li>
          <div class="key">设备租金：</div>
          <div class="value">¥{{ orderInfo.advance }}</div>
        </li>
          <li>
              <div class="key">服务费：</div>
              <div class="value">￥{{ orderInfo.serviceFee }}</div>
          </li>
          <li>
              <div class="key">申请时间：</div>
              <div class="value">{{ orderInfo.addTime }}</div>
          </li>
          <li>
              <div class="key">厂商确认时间：</div>
              <div class="value">{{ orderInfo.ptqrzjTime }}</div>
          </li>


          <template v-if="orderInfo.orderSatus!=70">
              <li>
                  <div class="key">平台签约时间：</div>
                  <div class="value">{{ orderInfo.qrhtTime }}</div>
              </li>
          <li>
              <div class="key">用电用户支付租金时间：</div>
              <div class="value">{{ orderInfo.khzfTime }}</div>
          </li>
          <li>
              <div class="key">厂商确认收款租金时间：</div>
              <div class="value">{{ orderInfo.csqrszTime }}</div>
          </li>
          <li>
              <div class="key">厂商支付平台（技术）服务费时间：</div>
              <div class="value">{{ orderInfo.cszffufTime }}</div>
          </li>
          <li>
              <div class="key">平台确认平台（技术）服务费时间：</div>
              <div class="value">{{ orderInfo.ptqrsxfTime }}</div>
          </li>
          <li>
              <div class="key">厂商安装验收时间：</div>
              <div class="value">{{ orderInfo.azysTime }}</div>
          </li>
          <li>
              <div class="key">设备确认送电时间：</div>
              <div class="value">{{ orderInfo.gateTime }}</div>
          </li>
          </template>

        <li v-if="orderInfo.orderSatus==70">
          <div class="key">订单中止时间：</div>
          <div class="value">{{ orderInfo.zzddTime }}</div>
        </li>
      </ul>
      <ul class="renew" v-if="orderInfo.status == 60">
        <li>
          <div class="key">续费时间：</div>
          <div class="value">{{ orderInfo.xftime }}</div>
        </li>
        <li>
          <div class="key">用电用户支付租金时间：</div>
          <div class="value">{{ orderInfo.xfkhzftime }}</div>
        </li>
        <li>
          <div class="key">平台确认租金时间：</div>
          <div class="value">{{ orderInfo.xfptqrzjtime }}</div>
        </li>
        <li>
          <div class="key">续费时长：</div>
          <div class="value">{{ orderInfo.xfday }}/月</div>
        </li>
        <li>
          <div class="key">厂商支付平台（技术）服务费时间：</div>
          <div class="value">{{ orderInfo.xfcszffwftime }}</div>
        </li>
        <li>
          <div class="key">平台确认平台（技术）服务费时间：</div>
          <div class="value">{{ orderInfo.xfptqrfwftime }}</div>
        </li>
        <li>
          <div class="key">续费价格：</div>
          <div class="value"><span>¥{{ orderInfo.xufeijg }}</span></div>
        </li>
        <li>
          <div class="key">平台结算厂商租金时间：</div>
          <div class="value">{{ orderInfo.xfptjszjtime }}</div>
        </li>
        <li>
          <div class="key">厂商确认收款租金时间：</div>
          <div class="value">{{ orderInfo.xfcsqrsktime }}</div>
        </li>
        <li>
          <div class="key">平台（技术）服务费：</div>
          <div class="value">¥{{orderInfo.xufeizk ? orderInfo.xfptfwfy * orderInfo.xufeizk : orderInfo.xfptfwfy }}</div>
        </li>
      </ul>
<!--      <ul class="suspend" v-if="orderInfo.orderSatus == 50">-->
<!--        <div class="caption">申请终止信息</div>-->
<!--        <div class="order-item-time">-->
<!--          <div class="item">-->
<!--            <span class="item-tit">申请终止时间：</span>{{ orderInfo.zzddTime }}-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <span class="item-tit">用电客户同意协议时间：</span-->
<!--            >{{ orderInfo.khtyxyTime }}-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <span class="item-tit">平台退款用电用户时间：</span-->
<!--            >{{ orderInfo.pttkkhTime }}-->
<!--          </div>-->

<!--          <div class="item">-->
<!--            <span class="item-tit">终止原因：</span-->
<!--            >{{ orderInfo.terminationReason }}-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <span class="item-tit">厂商确认协议时间：</span-->
<!--            >{{ orderInfo.csqrxyTime }}-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <span class="item-tit">用电客户收款时间：</span-->
<!--            >{{ orderInfo.khqrskTime }}-->
<!--          </div>-->

<!--          <div class="item">-->
<!--            <span class="item-tit">厂商确认时间：</span-->
<!--            >{{ orderInfo.csqrxyTime }}-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <span class="item-tit">平台退款厂商时间：</span-->
<!--            >{{ orderInfo.pttkcsTime }}-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <span class="item-tit">厂商确认收款时间：</span-->
<!--            >{{ orderInfo.csqrskTime }}-->
<!--          </div>-->
<!--        </div>-->
<!--        <div style="display: flex; justify-content: center; padding: 20px 0">-->
<!--          <el-button-->
<!--            type="info"-->
<!--            size="medium"-->
<!--            @click="confirmSuspend"-->
<!--            v-if="orderInfo.status == 1"-->
<!--            >确认-->
<!--          </el-button>-->
<!--        </div>-->
<!--      </ul>-->
    </div>
    <div class="renew-confirm" v-show="status == 1">
      <div class="title">价格确认</div>
      <div class="price">
        <!-- <div class="block">
					<ul>
						<li>
							<div class="key">租赁期限：</div>
							<div class="value">{{ renew.limit }}</div>
						</li>
						<li>
							<div class="key">套餐价格：</div>
							<div class="value">{{ commodity.price }}</div>
						</li>
						<li>
							<div class="key">折扣价：</div>
							<div class="value">{{ renew.discount }}</div>
						</li>
					</ul>
				</div>
				<div class="block">
					<ul>
						<li>
							<div class="key">单杆：</div>
							<div class="value">{{ renew.price_1 }}</div>
						</li>
						<li>
							<div class="key">架空线路：</div>
							<div class="value">{{ renew.price_2 }}</div>
						</li>
					</ul>
				</div> -->
        <div class="total">
          合计：
          <span>¥{{ Number.parseInt(renew.sum) + getSimTotal() }}</span>
        </div>
        <div style="
            width: 100%;
            display: flex;
            justify-content: end;
            margin-top: 20px;
            padding-bottom: 20px;
          ">
          <el-button type="info" size="medium" @click="confirmRenew">确认</el-button>
          <el-button type="info" size="medium" @click="refuseRenew">退回</el-button>
          <el-button
            v-if="orderInfo.serviceFeeRefund != 2"
            type="info"
            size="medium"
            @click="changeBaodian"
          >
            确定设备</el-button>
        </div>
      </div>
    </div>
<!--    <div-->
<!--      class="suspend-agreement"-->
<!--      v-if="orderInfo.orderSatus == 50 && orderInfo.status > 2"-->
<!--    >-->
<!--      <div class="title">终止订单协议</div>-->
<!--      <div class="contract">-->
<!--        <div class="cont">-->
<!--          <div class="img"><img src="../../assets/image/PDF.png" alt="" /></div>-->
<!--          <div class="right">-->
<!--            <div class="name">{{ "终止订单协议" }}</div>-->
<!--            <div class="time">{{ orderInfo.sctkxyTime || "无" }}</div>-->
<!--          </div>-->
<!--          <div style="margin-left: 150px; font-size: 16px">-->
<!--            <span>退款用电用户费用：￥{{ orderInfo.yonghufy }}</span>-->
<!--            <span style="margin-left: 50px"-->
<!--              >支付厂商费用：￥{{ orderInfo.changshangfy }}</span-->
<!--            >-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="download">-->
<!--          <el-button-->
<!--            type="warning"-->
<!--            plain-->
<!--            size="medium"-->
<!--            @click="openLink(orderInfo.tkUrl)"-->
<!--            >下载</el-button-->
<!--          >-->
<!--        </div>-->
<!--        <div-->
<!--          class="button"-->
<!--          v-if="orderInfo.status == 3 && orderInfo.statuson != 2"-->
<!--        >-->
<!--          <el-button type="info" size="medium" @click="agreeSuspend"-->
<!--            >同意</el-button-->
<!--          >-->
<!--          <el-button type="info" size="medium" plain @click="refuseSuspend"-->
<!--            >取消</el-button-->
<!--          >-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="record" v-show="status > 3">-->
<!--      <div class="title">支付信息</div>-->
<!--      <div class="hint">-->
<!--        *资金保管至平台，待平台确认设备发电后30天会结算给厂家。-->
<!--      </div>-->
<!--      <ul v-if="orderInfo && orderInfo.voucherList">-->
<!--        <li v-for="(item, index) in orderInfo.voucherList" :key="index">-->
<!--          <div>-->
<!--            <el-image-->
<!--              style="height: 150px; width: 150px; border: 1px solid #c5c5c5"-->
<!--              :src="$imgUrl + item.storageAdd"-->
<!--              :preview-src-list="[$imgUrl + item.storageAdd]"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="name">{{ item.voucherDesc }}</div>-->
<!--          <div class="action">{{ item.voucherSource }}</div>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
    <div class="payment" v-show="status == 24">
      <div class="title">支付服务费</div>
<!--      <div class="hint">-->
<!--        *请选择以下支付方式，支付完成后需要上传支付凭证后待审核通过后完成支付。-->
<!--      </div>-->
<!--      <ul style="padding: 20px 20px">-->
<!--        <li>-->
<!--          <div class="img">-->
<!--            <el-image-->
<!--              :src="payment.alipay"-->
<!--              :preview-src-list="[payment.alipay]"-->
<!--              style="width: 150px; height: 200px; border: 1px solid #bdbdbd"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="name">支付宝</div>-->
<!--        </li>-->
<!--        <li style="margin-left: 20px">-->
<!--          <div class="img">-->
<!--            <el-image-->
<!--              :src="payment.wechat"-->
<!--              :preview-src-list="[payment.wechat]"-->
<!--              style="width: 150px; height: 200px; border: 1px solid #bdbdbd"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="name">微信</div>-->
<!--        </li>-->
<!--        <li-->
<!--          style="-->
<!--            display: flex;-->
<!--            flex-direction: column;-->
<!--            width: 500px;-->
<!--            justify-content: space-between;-->
<!--            margin-left: 20px;-->
<!--          "-->
<!--        >-->
<!--          <span>帐户信息</span>-->
<!--          <span>收款单位：石家庄思凯电力建设有限公司供用电四分公司</span>-->
<!--          <span>地 址：石家庄高新区中山东路1009号</span>-->
<!--          <span>电 话：0311-66662607</span>-->
<!--          <span>开户银行：中国工商银行石家庄长安支行 </span>-->
<!--          <span>账 号：0402 0204 1930 0189 157</span>-->
<!--        </li>-->
<!--      </ul>-->
      <div style="padding: 20px">
<!--        <div style="margin-top: 20px">-->
<!--          *请把以上支付凭证上传至此（可上传多张）。-->
<!--        </div>-->
<!--        <el-upload-->
<!--          :before-upload="beforeAvatarUpload"-->
<!--          style="padding: 20px"-->
<!--          :action="$uploadUrl"-->
<!--          :multiple="false"-->
<!--          list-type="picture-card"-->
<!--          :on-success="handleAvatarSuccess"-->
<!--          :on-remove="handleRemove"-->
<!--          :accept="$imgExt"-->
<!--        >-->
<!--          <i class="el-icon-plus"></i>-->
<!--        </el-upload>-->
        <div class="btnGroup">
          <div
            class="btn scoreBtn" style="width: 120px"
            @click="uploadPaySuccess(34)"
            v-if="status == 24"
          >
            确认付款
          </div>
        </div>
      </div>
    </div>
    <!-- 上传收款凭证 -->
<!--    <div-->
<!--      class="payment"-->
<!--      v-show="-->
<!--        status == 26 ||-->
<!--          (orderInfo.orderSatus == 50 &&-->
<!--            orderInfo.status == 5 &&-->
<!--            orderInfo.statuson != 4)-->
<!--      "-->
<!--    >-->
<!--      <div class="title">上传收款凭证</div>-->
<!--      <div style="padding: 20px">-->
<!--        <el-upload-->
<!--          style="padding: 20px"-->
<!--          :action="$uploadUrl"-->
<!--          :before-upload="beforeAvatarUpload"-->
<!--          :multiple="false"-->
<!--          list-type="picture-card"-->
<!--          :on-success="handleAvatarSuccess"-->
<!--          :on-remove="handleRemove"-->
<!--          :accept="$imgExt"-->
<!--        >-->
<!--          <i class="el-icon-plus"></i>-->
<!--        </el-upload>-->
<!--        <div class="btnGroup">-->
<!--          <div-->
<!--            class="btn scoreBtn"-->
<!--            style="width: 80px"-->
<!--            @click="uploadPaySuccess(7)"-->
<!--            v-if="status == 26"-->
<!--          >-->
<!--            确认收款-->
<!--          </div>-->
<!--&lt;!&ndash;          <div&ndash;&gt;-->
<!--&lt;!&ndash;            class="btn scoreBtn"&ndash;&gt;-->
<!--&lt;!&ndash;            style="width: 80px"&ndash;&gt;-->
<!--&lt;!&ndash;            @click="stopSumbit"&ndash;&gt;-->
<!--&lt;!&ndash;            v-if="orderInfo.orderSatus == 50"&ndash;&gt;-->
<!--&lt;!&ndash;          >&ndash;&gt;-->
<!--&lt;!&ndash;            确认收款&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- 评价列表 -->
    <div class="card" v-show="status == 8">
      <div class="card-tit borderB">评价列表</div>
      <div class="evaluate-lists">
        <div
          class="evaluate-box evaluate-item"
          v-for="item in pinglunList"
          :key="item.id"
        >
          <div
            style="display: flex; justify-content: start; align-items: center"
          >
            <div class="user-name">{{ item.masterName }}</div>
            <span style="margin-left: 40px">评分</span>
            <div class="score-line">
              <el-rate
                v-model="item.fractionUser"
                disabled
                show-score
                text-color="#ff9900"
                score-template=""
              >
              </el-rate>
            </div>
            <div class="user-name time" style="margin-left: 20px">
              {{ item.updateTime }}
            </div>
          </div>
          <div class="evaluate" style="margin: 20px 0">{{ item.proposal }}</div>
          <div class="imgs" v-if="item.proposalUrl != null">
            <!-- <img :src="$imgUrl + item1" style="width: 200px;height: 150px;"
							v-for="item1 in item.proposalUrl.split(',')" :key="item1"> -->
            <el-image
              :src="$imgUrl + item1"
              class="fileImg evaluate-img"
              :preview-src-list="[$imgUrl + item1]"
              v-for="item1 in item.proposalUrl.split(',')"
              :key="item1"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 厂商回复内容 -->
    <div class="card" v-if="status == 8 && orderInfo.estimate">
      <div class="card-tit borderB">回复内容</div>
      <div class="evaluate-lists">
        <div class="evaluate-box evaluate-item">
          <div
            style="display: flex; justify-content: start; align-items: center"
          >
            <div class="user-name">{{ orderInfo.companyName }}</div>
            <!-- <span style="margin-left: 40px;">评分</span>
						<div class="score-line">
							<el-rate v-model="item.fractionUser" disabled show-score text-color="#ff9900"
								score-template="">
							</el-rate>
						</div> -->
            <div class="user-name time" style="margin-left: 20px">
              {{ orderInfo.cshfTime }}
            </div>
          </div>
          <div class="evaluate" style="margin: 20px 0">
            {{ orderInfo.estimate }}
          </div>
          <div class="imgs" v-if="orderInfo.factoryPingJiaImg != null">
            <!-- <img :src="$imgUrl + item1" style="width: 200px;height: 150px;"
							v-for="item1 in item.proposalUrl.split(',')" :key="item1"> -->
            <el-image
              :src="$imgUrl + item1"
              class="fileImg evaluate-img"
              :preview-src-list="[$imgUrl + item1]"
              v-for="item1 in orderInfo.factoryPingJiaImg.split(',')"
              :key="item1"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 评价 -->
    <div class="card" v-if="status == 8 && !orderInfo.estimate">
      <div class="card-tit">回复评价</div>
      <div>
        <el-input
          type="textarea"
          resize="none"
          :rows="4"
          placeholder="请输入内容"
          v-model="huifu.estimate"
          style="width: 300px"
        />
        <div class="upload-box" style="padding-bottom: 20px; padding-top: 20px">
          <p class="upload-add" style="padding-bottom: 20px">图片上传</p>
          <el-upload
            :action="$uploadUrl"
            list-type="picture-card"
            :before-upload="beforeAvatarUpload"
            :multiple="false"
            :accept="$imgExt"
            :on-success="handleCertSuccess"
            :on-remove="handleRemove1"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
        <!-- <div class="score-box" style="">
					<div class="score-tit">客户评分</div>
					<div class="score-line">
						<el-rate v-model="huifu.rate"></el-rate>
					</div>
				</div> -->
        <el-button size="medium" type="info" @click="pingjia()">评价</el-button>
      </div>
    </div>
    <!-- 续费确认价格 -->
<!--    <div class="renew-confirm" v-if="status == 60">-->
<!--      <div class="title">价格确认</div>-->
<!--      <div-->
<!--        style="-->
<!--          display: flex;-->
<!--          justify-content: space-around;-->
<!--          align-items: center;-->
<!--          padding: 20px 0;-->
<!--          font-size: 14px;-->
<!--        "-->
<!--      >-->
<!--        <span>租赁期限：{{ orderInfo.xfday }}月</span>-->
<!--        <span>套餐价格：￥{{ orderInfo.xufeijg }}</span>-->
<!--        <span>折扣价：￥{{ (orderInfo.xufeijg * xufeizk).toFixed(2) }}</span>-->
<!--        <el-input size="medium" v-model="xufeizk" style="width: 200px">-->
<!--          <template slot="append"-->
<!--            >折</template-->
<!--          >-->
<!--        </el-input>-->
<!--      </div>-->
<!--      <div-->
<!--        class=""-->
<!--        style="-->
<!--          display: flex;-->
<!--          justify-content: center;-->
<!--          align-items: center;-->
<!--          padding: 20px 0;-->
<!--        "-->
<!--      >-->
<!--        <el-button size="medium" type="info" @click="xufeiOk">确认</el-button>-->
<!--        <el-button size="medium" type="info" @click="xufeiNo">拒绝</el-button>-->
<!--      </div>-->
<!--    </div>-->
    <account-dialog ref="accountDialogRef"></account-dialog>
  </div>
</template>

<script>
import AccountDialog from "../../view/orderDetail/accountList.vue";
import {
  equOrderDetail,
  updateOrder,
  addVoucherAllApi,
  delOrder,
} from "../../http/factory/add-eme.js";
import { updateCarOrder } from "../../http/api/ordinary.js";
import serverConfig from "@/http/config";
export default {
  name: "detail",
  components: {
    AccountDialog,
  },
    filters: {
        formatDate(date1) {
            let date = new Date(date1)
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hour = String(date.getHours()).padStart(2, '0');
            const minute = String(date.getMinutes()).padStart(2, '0');

            // 格式化为 'YYYY-MM-DD HH:mm' 的形式
            return `${year}-${month}-${day}`;
        }
    },
  data() {
    return {
      imgUrl:serverConfig.baseURL,
      fileList: [],
      xufeizk: 0.85,
      huifu: {
        estimate: "",
        rate: 0,
        factoryPingJiaImg: "",
        reply: 2,
        cshfTime: "",
      },
      uploadUrl: "",
      imageUrl: [],
      statusName: "已完成",
      status: "",
      commodity: {
        img: require("../../assets/image/img_3.png"),
        name: "",
        price: "200/3月",
      },
      device: {
        username: "",
        type: "箱变",
        capacity: "54",
        position: "河北石家庄",
        voltage: "220V",
      },
      scheme: {
        price_1: "1000元/套",
        price_2: "3800元/档",
        price_3: "135元/米",
      },
      user: {
        avatar: require("../../assets/image/avatar.png"),
        username: "",
        address: "",
        limit: "12个月",
        start: "2022/6/19",
        end: "2023/6/19",
        venner: "2000元/1个",
        line: "2000元/1档",
      },
      renew: {
        limit: "12个月",
        start: "2022/6/19",
        end: "2023/6/19",
        total: "4000",
        sum: "3500",
        discount: "0.0",
        discountNum: 85,
        price_1: "",
        price_2: "",
        renew_price: "",
      },
      contract: {
        name: "",
        time: "",
        filePath: "",
      },
      order: {
        applyTime: "",
        payTime: "",
        confirmTime: "",
        confirmContract: "",
        payServiceTime: "",
        confirmServiceTime: "",
        series: "",
        installTime: "",
        powerTime: "",
        rent: "",
        settleTime: "",
        receiveTime: "",
        renew: {
          applyTime: "",
          payTime: "",
          confirmTime: "",
          limit: "",
          payServiceTime: "",
          confirmServiceTime: "",
          price: "",
          settleTime: "",
          receiveTime: "",
        },
        suspend: {
          applyTime: "",
          reason: "",
          confirmTime: "",
        },
      },
      suspendContract: {
        name: "",
        time: "",
        filePath: "",
      },
      record: [],
      payment: {
        alipay: require("../../assets/image/ali.jpg"),
        wechat: require("../../assets/image/wechat.jpg"),
        unipay: require("../../assets/image/qrcode.png"),
      },
      id: "",
      orderInfo: {},
      accountList: [],
      pinglunList: [],
      htUrl: "",
      orderPro: {},
      equList: [],
      loading: [],
    };
  },
  methods: {
    beforeAvatarUpload() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    getSimTotal() {
      let total = 0;
      for (let item of this.equList) {
        total +=
          item.dsbjkxl * item.priceGears.jkxl +
          item.dsbdlxl * item.priceGears.dlxl +
          item.dsbdgxl * item.priceGears.dgxl;
      }
      return total;
    },
    xufeiOk() {
      updateOrder({
        id: this.orderInfo.id,
        xufeizk: this.xufeizk,
        xufeijg: this.orderInfo.xufeijg * this.xufeizk,
        // xfptfwfy: this.orderInfo.xfptfwfy,
        status: 60,
        orderSatus: 3,
        orderType: 0,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "提交成功",
        });
        this.$router.go(-1);
      });
    },
    xufeiNo() {
      updateOrder({
        id: this.orderInfo.id,
        orderSatus: 7,
        status: 0,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "提交成功",
        });
        this.$router.go(-1);
      });
    },
    afterUpload() {
      if (this.imageUrl == null) {
        return this.$message("请上传图片");
      }
      updateOrder({
        id: this.orderInfo.id,
        status: 4,
        // ptqrzjTime: new Date(),
        ptqrzjTime: this.formatTime(),
        voucher: {
          storageAdd: this.imageUrl,
          type: 0,
        },
      }).then((res) => {
        this.$message({
          type: "success",
          message: "提交成功",
        });
        this.$router.go(-1);
      });
    },
    afterReceiveUpload() {
      if (this.imageUrl == null) {
        return this.$message("请上传图片");
      }
      updateOrder({
        id: this.orderInfo.id,
        status: 7,
        // ptqrzjTime: new Date(),
        ptqrzjTime: this.formatTime(),
        voucher: {
          storageAdd: this.imageUrl,
          type: 0,
        },
      }).then((res) => {
        this.$message({
          type: "success",
          message: "提交成功",
        });
        this.$router.go(-1);
      });
    },
    afterSumbit() {
      updateOrder({
        id: this.orderInfo.id,
        status: 2,
        advance: this.orderInfo.advance,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "提交成功",
        });
        this.$router.go(-1);
      });
    },
    // 订单支付信息上传图片删除方法
    handleRemove(e, fileList) {
      console.log("删除", e.response.fileName);
      console.log("shanchju", this.imageUrl);
      var a = this.imageUrl.indexOf(e.response.fileName);
      if (a > -1) {
        this.imageUrl.splice(a, 1);
        console.log("卡", this.imageUrl);
      }
    },
    // 评论图片删除方法
    handleRemove1(e) {
      console.log("删除", e.response.fileName);
      console.log("shanchju", this.fileList);
      var a = this.fileList.indexOf(e.response.fileName);
      if (a > -1) {
        this.fileList.splice(a, 1);
        console.log("卡", this.fileList);
      }
    },
    handleCertSuccess(file) {
      setTimeout(() => {
        this.loading.close();
        this.fileList.push(file.fileName);
      }, 1000);
    },
    handleAvatarSuccess(file) {
      setTimeout(() => {
        this.loading.close();
        this.imageUrl.push(file.fileName);
      }, 1000);
    },
    // beforeAvatarUpload() {},
    contactService() {
      this.$router.push({
        path: "/service",
      });
    },
    downloadFile() {
      if (!this.htUrl) {
        return this.$message("当前合同不能下载");
      }
      window.open(this.htUrl);
    },
    checkOrder() {
      this.$refs.accountDialogRef.showDialog(this.accountList);
    },
    confirmSuspend() {
      updateOrder({
        id: this.id,
        orderSatus: 50,
        status: 2,
        // csqrxyTime: new Date(),
        csqrxyTime: this.formatTime(),
      }).then((res) => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      });
    },
    //确认订单
    confirmRenew() {
      let aa = this.renew.sum;
      let bb = this.getSimTotal();
        this.$confirm('您确定接收当前订单吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            updateCarOrder({
                id: this.id,
                orderSatus: 2,
                advance: parseFloat(aa) + parseFloat(bb),
                fuwuFangan: this.equList,
                orderType: 0,
                active: "changeParams",
                ptqrzjTime:this.formatTime()
            }).then((res) => {
                this.$message({
                    type: "success",
                    message: "操作成功",
                });
                localStorage.removeItem("orderInfo_" + this.id);
                this.$router.go(-1);
            });
        })

    },
    refuseRenew() {

        this.$confirm('您确定当前订单吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            updateOrder({
                id: this.id,
                orderSatus: 0,
            }).then((res) => {
                this.$message({
                    message: "退回订单成功！",
                    type: "success",
                    duration: 2000,
                });
                localStorage.removeItem("orderInfo_" + this.id);
                this.$router.go(-1);
            })
        })
   ;
    },
    changeBaodian() {
      this.$router.push({
        path: "/factoryUser/changeEqu",
        query: {
          equId: this.orderInfo.equipmentId,
          orderId: this.orderInfo.id,
          factoryId: this.orderInfo.businessId,
          type: 1,
        },
      });
    },
    changeBaodianD(id) {
      this.$router.push({
        path: "/factoryUser/changeEqu",
        query: {
          equId: id,
          orderId: this.orderInfo.id,
          factoryId: this.orderInfo.businessId,
          type: 2,
        },
      });
    },
    //打开退款协议
    openLink(link) {
      if (!link) {
        return this.$message("当前合同不能下载");
      }
      window.open(this.$imgUrl + link);
    },
    agreeSuspend() {
      updateOrder({
        id: this.id,
        orderSatus: 50,
        // csqrxyTime: new Date(),
        csqrxyTime: this.formatTime(),
        statuson: 2,
        status: this.orderInfo.statuson == 1 ? 4 : 3,
      }).then((res) => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      });
    },
    refuseSuspend() {
      this.$router.go(-1);
    },
    uploadPaySuccess(status) {
      let voucherDesc = "";
      let voucherSource = "";
      let timeKey = "";
      if (status == 34) {
        voucherDesc =
          this.orderInfo.status == 60
            ? "平台（技术）服务费(续)"
            : "平台（技术）服务费";
        voucherSource = "厂商-支付";
        timeKey = this.orderInfo.status == 60 ? "xfcszffwftime" : "cszffufTime";
      }
      if (status == 7) {
        voucherDesc = this.orderInfo.status == 60 ? "设备租金(续)" : "设备租金";
        voucherSource = "厂商-收款";
        timeKey = this.orderInfo.status == 60 ? "xfcsqrsktime" : "csqrszTime";
      }
      // if (this.imageUrl.length <= 0) {
      //   this.$message({
      //     message: "请上传凭证",
      //     type: "warning",
      //   });
      //   return;
      // }
      // console.log(this.imageUrl);
      // return
      let arr = [];
      for (let item of this.imageUrl) {
        arr.push({
          orderId: this.id,
          type: 0,
          storageAdd: item,
          voucherDesc,
          voucherSource,
        });
      }
      // addVoucherAllApi({
      //   voucherList: arr,
      // });
      let obj = {
        id: this.id,
        orderSatus: status,
      };

      // obj[timeKey] = new Date()
      obj[timeKey] = this.formatTime();
        this.$confirm('您确定收到租金，并且已经支付给平台服务费了吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            obj.csqrszTime = this.formatTime();
            obj.cszffufTime = this.formatTime();
            updateOrder(obj).then((res) => {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$router.go(-1);
            });
        })

    },
    stopSumbit() {
      if (this.imageUrl.length <= 0) {
        this.$message({
          message: "请上传凭证",
          type: "warning",
        });
        return;
      }
      let voucherDesc = "终止订单费用";
      let voucherSource = "厂商-收款";
      let arr = [];
      for (let item of this.imageUrl) {
        arr.push({
          orderId: this.id,
          type: 1,
          storageAdd: item,
          voucherDesc,
          voucherSource,
        });
      }
      addVoucherAllApi({
        voucherList: arr,
      });
      updateOrder({
        id: this.id,
        orderSatus: 50,
        // csqrskTime: new Date(),
        csqrskTime: this.formatTime(),
        statuson: 4,
        status: this.orderInfo.statuson == 3 ? 6 : 5,
      }).then((res) => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      });
    },
    fetchData() {
      equOrderDetail({
        id: this.id,
      }).then((res) => {
        let orderInfo = [];
        if (localStorage.getItem("orderInfo_" + this.id)) {
          orderInfo = JSON.parse(localStorage.getItem("orderInfo_" + this.id));
          if (orderInfo.id == this.id) {
            this.equList = JSON.parse(orderInfo.equipmentList);
          } else {
            this.equList = JSON.parse(data.equipmentList);
            localStorage.setItem("orderInfo_" + this.id, JSON.stringify(res));
          }
        } else {
          this.equList = JSON.parse(res.equipmentList);
          localStorage.setItem("orderInfo_" + this.id, JSON.stringify(res));
        }
        // this.equList = JSON.parse(res.equipmentList);
        this.accountList = res.accountsList;
        this.orderInfo = res;
        // if (res.orderSatus == 1) {
        //   this.statusName = "待确认";
        // }
        // if (res.orderSatus == 2) {
        //   this.statusName = "待签约";
        // }
        // if (res.orderSatus == 3) {
        //   this.statusName = "待支付租金";
        // }
        // if (res.orderSatus == 4) {
        //   this.statusName = "已支付租金（待平台确认）";
        // }
        // if (res.orderSatus == 24) {
        //   this.statusName = "待支付服务费";
        // }
        // if (res.orderSatus == 34) {
        //   this.statusName = "已支付服务费（待平台确认）";
        // }
        // if (res.orderSatus == 5) {
        //   this.statusName = "待安装验收";
        // }
        // if (res.orderSatus == 6) {
        //   this.statusName = "待用户确认送电";
        // }
        // if (res.orderSatus == 16) {
        //   this.statusName = "待结款";
        // }
        // if (res.orderSatus == 26) {
        //   this.statusName = "已结款（待确认收款）";
        // }
        // if (res.orderSatus == 7) {
        //   this.statusName = "已完成";
        // }
        // if (res.orderSatus == 8) {
        //   this.statusName = "已评价";
        // }
        // if (res.orderSatus == 50) {
        //   if (res.status == 1) {
        //     this.statusName = "终止申请中（待厂商确认）";
        //   } else if (res.status == 2) {
        //     this.statusName = "终止申请中（待平台确认）";
        //   } else if (res.status == 3) {
        //     if (res.statuson == 2) {
        //       this.statusName = "终止订单（待客户确认协议）";
        //     } else {
        //       this.statusName = "终止订单（待确认协议）";
        //     }
        //   } else if (res.status == 4) {
        //     this.statusName = "已终止（退款中）";
        //   } else if (res.status == 5) {
        //     if (res.statuson == 4) {
        //       this.statusName = "已终止";
        //     } else {
        //       this.statusName = "已终止（待确认收款）";
        //     }
        //   } else if (res.status == 6) {
        //     this.statusName = "已终止";
        //   } else {
        //     this.statusName = "终止订单";
        //   }
        // }
        // if (res.orderSatus == 60) {
        //   this.statusName = "续费申请";
        // }
        this.status = res.orderSatus;
        this.commodity.img = this.$imgUrl + res.pictureUrl;
        this.htUrl = this.$imgUrl + res.htUrl;
        this.commodity.name = res.title;
        if (res.serviceFeeRefund != 2) {
          this.commodity.price = res.priceGears.price + "/3月";
          this.user.venner = res.priceGears.dgxl + "元/个";
          this.user.line = res.priceGears.jkxl + "元/米";
          this.user.dlxl = res.priceGears.dlxl + "元/档";
          this.renew.price_1 = res.priceGears.dgxl + "元/1个";
          this.renew.price_2 = res.priceGears.jkxl + "/1档";
        }

        this.device.username = res.userName;
        this.device.type = res.typeName;
        this.device.capacity = res.volume;
        this.device.position = res.provinceName + res.cityName;
        this.device.voltage = res.voltage;
        this.user.username = res.masterName;
        this.user.address =
          res.uprovinceName + res.ucityName + res.ucountyName + res.uaddress;
        this.orderPro = res.orderPro;
        this.user.limit = res.orderPro.duration + "个月";
        this.user.start = res.startTime;
        this.user.end = res.entTime;

        this.order.applyTime = res.addTime;
        this.order.payTime = res.khzfTime;
        this.order.confirmTime = res.ptqrzjTime;
        this.order.confirmContract = res.qrhtTime;
        this.order.payServiceTime = res.cszffufTime;
        this.order.confirmServiceTime = res.ptqrsxfTime;
        this.order.series = res.orderNo;
        this.order.installTime = res.azysTime;
        this.order.powerTime = res.gateTime;
        this.order.rent = res.advance;
        this.order.settleTime = res.ptjscsTime;
        this.order.receiveTime = res.csqrszTime;
        this.renew.limit = res.orderPro.duration + "个月";
        this.renew.start = res.startTime;
        this.renew.end = res.entTime;
        this.renew.total = res.advance;
        this.renew.discount = 0.0;
        this.renew.discountNum = 111;

        this.renew.renew_price = 111;
        this.pinglunList = res.emergencyPowerProtectionOrders;
        //计算设备价格
        let total = 0;
        for (let item of this.equList) {
          console.log(res.orderPro.duration);
          if (res.orderPro.duration == 3) {
            total += item.priceGears.price;
            console.log(item.priceGears.price);
          }
          if (res.orderPro.duration == 6) {
            total += item.priceGears.price1;
            console.log(item.priceGears.price1);
          }
          if (res.orderPro.duration == 9) {
            total += item.priceGears.price2;
            console.log(item.priceGears.price2);
          }
          if (res.orderPro.duration == 12) {
            total += item.priceGears.price3;
            console.log(item.priceGears.price3);
          }
        }
        for (let index in this.equList) {
          // console.log(this.equList[index].priceGears);
          // return
          if (res.orderPro.duration == 3) {
            this.equList[index].duration_price = this.equList[
              index
            ].priceGears.price;
          } else if (res.orderPro.duration == 6) {
            this.equList[index].duration_price = this.equList[
              index
            ].priceGears.price1;
          } else if (res.orderPro.duration == 9) {
            this.equList[index].duration_price = this.equList[
              index
            ].priceGears.price2;
          } else if (res.orderPro.duration == 12) {
            this.equList[index].duration_price = this.equList[
              index
            ].priceGears.price3;
          } else {
            this.equList[index].duration_price = 0;
          }
        }
        this.renew.sum = total;
      });
    },
    compHandle() {
        this.$confirm('您确定已经安装验收了吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            updateOrder({
                id: this.id,
                orderSatus: 6,
                // azysTime: new Date(),
                azysTime: this.formatTime(),
            }).then((res) => {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$router.go(-1);
            });
        })

    },
    pingjia() {
      if (this.fileList.length <= 0) {
        this.$message({
          message: "请上传评价图片",
          type: "warning",
        });
        return;
      }
      if (this.huifu.estimate == "") {
        this.$message({
          message: "请填写评价内容",
          type: "warning",
        });
        return;
      }
      // if (this.huifu.rate == 0) {
      // 	this.$message({
      // 		message: '请选择评分',
      // 		type: 'warning'
      // 	});
      // 	return
      // }
      this.huifu.id = this.id;
      this.huifu.factoryPingJiaImg = this.fileList.join(",");

      // this.huifu.cshfTime = new Date()
      this.huifu.cshfTime = this.formatTime();

      updateOrder(this.huifu).then((res) => {
        this.$message({
          message: "评价成功",
          type: "success",
        });
        this.$router.go(-1);
      });
    },
  },
  created: function() {
    this.id = this.$route.query.id;
    this.fetchData();
  },
};
</script>

<style lang="less" scoped="scoped">
.change-parms-box {
  display: flex;
  padding: 20px 0;

  .item {
    padding-top: 20px;
    margin-right: 20px;

    p {
      margin-bottom: 10px;
    }
  }
}

.detail-box {
  margin-bottom: 20px;
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;

  .device-box {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .device-img {
      width: 200px;
      height: 200px;
      border-radius: 10px;
      margin-right: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .device-info {
      width: 30%;

      .name {
        font-size: 15pxs;
        color: #333333;
        line-height: 20px;
        font-weight: 500;
      }

      .price-box {
        margin-top: 20px;
        font-size: 0.14rem;
        color: #000000;
        line-height: 20px;
        align-items: center;
        position: relative;

        .price {
          color: #ff4141;
          margin-left: 20px;
        }
      }

      .tips {
        font-size: 14px;
        color: #8f8f8f;
        line-height: 20px;
        margin-top: 20px;
      }
    }

    .info {
      width: 60%;
      border: 1px solid #f2f2f2;

      .title {
        height: 40px;
        background: #fff3ec;
        line-height: 40px;
        padding-left: 10px;

        p {
          font-size: 20px;
          color: #000000;
        }
      }

      .info-intro {
        display: flex;
        flex-wrap: wrap;

        .item {
          margin: 30px 10px;
          width: 30%;
          font-size: 15px;

          label {
            color: #afafaf;
          }

          span {
            margin-left: 20px;
            color: #000000;
          }
        }
      }
    }

    .btns {
      flex: 1;
      text-align: right;
      padding-right: 0.22rem;

      .apply {
        width: 1.07rem;
        height: 0.42rem;
        background: #fa6600;
        border-radius: 0.06rem;
        font-size: 0.14rem;
        color: #ffffff;
        line-height: 0.42rem;
        text-align: center;
        border: none;
      }

      .service {
        width: 1.07rem;
        height: 0.42rem;
        background: #ffffff;
        border-radius: 0.06rem;
        border: 1px solid #fa6600;
        font-size: 0.14rem;
        color: #fa6600;
        line-height: 0.42rem;
        text-align: center;
        margin-top: 0.2rem;
      }
    }
  }

  .intro-box {
    margin-top: 20px;

    .title {
      font-size: 0.16rem;
      color: #000000;
    }

    .service-plan {
      margin-top: 20px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 20px;
      background: #f9f9f9;
      border-radius: 0.06rem;

      .item {
        line-height: 0;
        padding: 0.15rem 0.2rem;

        label {
          display: inline-block;
          min-width: 0.9rem;
          font-size: 0.14rem;
          line-height: 0.24rem;
          color: #aaaaaa;
          margin-right: 0.2rem;
          text-align: right;
        }

        span {
          font-size: 0.14rem;
          line-height: 0.24rem;
          color: #333333;
        }
      }
    }
  }
}

.order-item-time {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  line-height: 40px;

  .item {
    width: 30%;
    color: #000;

    span {
      color: #686868;
    }
  }
}

.btnGroup {
  display: flex;
  justify-content: center;

  .btn {
    width: 40px;
    background: #686868;
    border-radius: 6px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    padding: 10px 20px;
    cursor: pointer;
  }
}

.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.avatar-uploader-icon:hover {
  border-color: #409eff;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.order-status {
  width: 100%;
  height: 60px;
  padding: 0px @vue-spacing-row-lg;
  box-sizing: border-box;
  background: @vue-bg-color;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: orange;
}

.case {
  width: 100%;
  padding: 0px @vue-spacing-row-lg;
  padding-top: 50px;
  box-sizing: border-box;
  background: @vue-bg-color;
  margin-top: @vue-spacing-col-lg;

  .block {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .commodity,
    .device {
      width: calc((100% - 220px) / 2);
    }

    .img {
      width: 220px;
      height: 220px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .commodity {
      padding: 0px @vue-spacing-row-base;
      box-sizing: border-box;

      .name {
        width: 100%;
        line-height: 40px;
        font-size: @vue-font-size-sm;
        font-weight: bold;
      }

      .price {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        font-size: @vue-font-size-sm - 2;

        span {
          color: @vue-text-color-red;
          font-size: @vue-font-size-sm + 2;
          font-weight: bold;
        }
      }

      .hint {
        width: 100%;
        line-height: 30px;
        font-size: @vue-font-size-min;
        color: orange;
      }
    }

    .device {
      border: 1px solid orange;

      .title {
        width: 100%;
        height: 40px;
        background: #fff2ee;
        padding: 0px @vue-spacing-row-base;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .padding {
          width: 4px;
          height: 20px;
          background: @vue-bg-color-red;
          margin-right: @vue-spacing-row-sm;
        }
      }

      ul {
        width: 100%;
        background: #fffcfe;
        padding: 0px @vue-spacing-row-base;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;

        li {
          width: 50%;
          height: 50px;
          display: flex;

          .key,
          .value {
            height: 100%;
            display: flex;
            align-items: center;
            font-size: @vue-font-size-min;
          }

          .key {
            width: 80px;
            color: @vue-text-color-grey;
          }

          .value {
            width: calc(100% - 80px);
          }
        }
      }
    }
  }

  .scheme-block {
    width: 100%;
    padding-bottom: @vue-spacing-col-lg;

    .scheme-title {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
    }

    .scheme-list {
      width: 100%;
      background: @vue-bg-color-grey;
      display: flex;
      flex-wrap: wrap;
      padding: 0px @vue-spacing-row-base;
      box-sizing: border-box;

      li {
        height: 50px;
        display: flex;
        justify-content: space-between;
        margin-right: @vue-spacing-row-lg;

        .key,
        .value {
          height: 100%;
          display: flex;
          align-items: center;
          font-size: @vue-font-size-sm - 2;
        }

        .key {
          color: @vue-text-color-grey;
        }
      }
    }
  }
}

.userinfo {
  width: 100%;
  background: @vue-bg-color;
  margin-top: @vue-spacing-col-lg;

  .title {
    width: 100%;
    height: 50px;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-bottom: 1px solid @vue-border-color;
  }

  .user {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
    border-bottom: 1px solid @vue-border-color;

    .avatar {
      width: 60px;
      height: 60px;
      border-radius: @vue-border-radius-circle;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .name {
      height: 100%;
      display: flex;
      align-items: center;
      font-size: @vue-font-size-sm;
      font-weight: bold;
      padding: @vue-spacing-row-base;
      box-sizing: border-box;
    }

    ul {
      height: 100%;
      display: flex;
      align-items: center;

      li {
        padding: 0px @vue-spacing-row-lg;
        box-sizing: border-box;

        .key,
        .value {
          height: 25px;
          display: flex;
          align-items: center;
          font-size: @vue-font-size-sm - 2;
        }

        .key {
          color: @vue-text-color-grey;
        }
      }

      li:first-child {
        border-left: 1px solid @vue-border-color;
      }
    }
  }

  .renew {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;

    li {
      height: 100%;
      display: flex;
      margin: 0px @vue-spacing-row-lg;

      .key,
      .value {
        height: 100%;
        display: flex;
        align-items: center;
        font-size: @vue-font-size-min;
      }

      .key {
        width: 80px;
        color: @vue-text-color-grey;
      }

      .value {
        width: calc(100% - 80px);
      }
    }
  }
}

.file,
.suspend-agreement {
  width: 100%;
  background: @vue-bg-color;
  margin-top: @vue-spacing-col-lg;

  .title {
    width: 100%;
    height: 50px;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-bottom: 1px solid @vue-border-color;
  }

  .hint {
    line-height: 40px;
    font-size: @vue-font-size-min;
    color: @vue-text-color-red;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
  }

  .contract {
    width: 100%;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;

    .cont {
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;

      .img {
        width: 60px;
        height: 60px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .right {
        margin-left: @vue-spacing-row-base;

        .name,
        .time {
          line-height: 30px;
          font-size: @vue-font-size-sm - 2;
        }

        .name {
          span {
            color: orange;
          }
        }

        .time {
          color: @vue-text-color-grey;
        }
      }
    }

    .download {
      width: 100%;
      height: 60px;
      padding-top: 10px;
      box-sizing: border-box;
    }

    .button {
      width: 100%;
      height: 60px;
      padding-top: 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      .el-button {
        width: 120px;
      }
    }
  }
}

.order {
  width: 100%;
  background: @vue-bg-color;
  margin-top: @vue-spacing-col-lg;

  .title {
    width: 100%;
    height: 50px;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid @vue-border-color;
  }

  .time-list,
  .renew {
    width: 100%;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;

    li {
      width: 33.3%;
      height: 40px;
      display: flex;

      .key,
      .value {
        height: 100%;
        display: flex;
        align-items: center;
        font-size: @vue-font-size-min;
      }

      .key {
        color: @vue-text-color-grey;
      }
    }
  }

  .renew {
    border-top: 1px solid @vue-border-color;
  }

  .suspend {
    width: 100%;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
    border-top: 1px solid @vue-border-color;

    .caption {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      font-size: @vue-font-size-sm;
    }

    li {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      font-size: @vue-font-size-sm - 2;

      .key {
        color: @vue-text-color-grey;
      }
    }

    .button {
      width: 100%;
      height: 60px;
      padding-top: 10px;
      box-sizing: border-box;
    }
  }
}

.renew-confirm {
  width: 100%;
  background: @vue-bg-color;
  margin-top: @vue-spacing-col-lg;

  .title {
    width: 100%;
    height: 50px;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid @vue-border-color;
  }

  .hint {
    line-height: 40px;
    font-size: @vue-font-size-min;
    color: @vue-text-color-red;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
  }

  .price {
    width: 100%;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;

    .block {
      background: @vue-bg-color-grey;
      width: 100%;
      height: 60px;
      display: flex;

      ul {
        width: 800px;
        display: flex;
        align-items: center;

        li {
          width: 33.3%;
          height: 40px;
          display: flex;
          padding-left: @vue-spacing-row-base;
          box-sizing: border-box;

          .key,
          .value {
            height: 100%;
            display: flex;
            align-items: center;
            font-size: @vue-font-size-min;
          }

          .key {
            color: @vue-text-color-grey;
          }
        }
      }

      .input {
        width: calc(100% - 800px);
        height: 100%;
        display: flex;
        align-items: center;
        font-size: @vue-font-size-min;

        .el-input {
          width: 80px;
        }

        .el-input,
        .el-button {
          margin: 0px @vue-spacing-row-sm;
        }
      }
    }

    .total {
      width: 100%;
      height: 50px;
      line-height: 50px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      font-size: @vue-font-size-sm - 2;

      span {
        color: @vue-text-color-red;
        font-size: @vue-font-size-sm + 2;
      }
    }

    .button {
      width: 100%;
      height: 60px;
      padding-top: 10px;
      box-sizing: border-box;
    }
  }
}

.record {
  width: 100%;
  width: 100%;
  background: @vue-bg-color;
  margin-top: @vue-spacing-col-lg;

  .title {
    width: 100%;
    height: 50px;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid @vue-border-color;
  }

  .hint {
    line-height: 40px;
    font-size: @vue-font-size-min;
    color: @vue-text-color-red;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
  }

  ul {
    width: 100%;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;

    li {
      width: 140px;
      margin-right: @vue-spacing-row-lg;
      margin-bottom: @vue-spacing-col-lg;

      .img {
        width: 100%;
        height: 240px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .name,
      .action {
        width: 100%;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .name {
        font-size: @vue-font-size-sm - 2;
      }

      .action {
        font-size: @vue-font-size-min;
        color: @vue-text-color-grey;
      }
    }
  }
}

.payment {
  width: 100%;
  width: 100%;
  background: @vue-bg-color;
  margin-top: @vue-spacing-col-lg;

  .title {
    width: 100%;
    height: 50px;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid @vue-border-color;
  }

  .hint {
    line-height: 40px;
    font-size: @vue-font-size-min;
    color: @vue-text-color-red;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
  }

  ul {
    width: 100%;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;

    li {
      width: 140px;
      margin-right: @vue-spacing-row-lg;

      .img {
        width: 100%;
        height: 140px;

        a,
        img {
          width: 100%;
          height: 100%;
        }
      }

      .name {
        width: 100%;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: @vue-font-size-sm - 2;
      }
    }
  }

  .upload {
    width: 100%;

    .upload-area {
      width: 100%;
      padding: 0px @vue-spacing-row-lg;
      box-sizing: border-box;
    }
  }

  .button {
    width: 100%;
    height: 60px;
    padding: 0px @vue-spacing-row-lg;
    padding-top: 10px;
    box-sizing: border-box;
    box-sizing: border-box;
  }
}

.evaluate {
  width: 100%;
  width: 100%;
  background: @vue-bg-color;
  margin-top: @vue-spacing-col-lg;

  .title {
    width: 100%;
    height: 50px;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid @vue-border-color;
  }

  .content {
    width: 100%;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;

    span {
      display: flex;
      justify-content: center;
      line-height: 80px;
      color: @vue-text-color-red;
    }
  }
}

.imgs {
  padding-left: 0.88rem;
  box-sizing: border-box;
  font-size: 0;
}

.evaluate-img {
  width: 8.78rem;
  height: 8.78rem;
  margin-right: 1.13rem;
  margin-bottom: 0.1rem;
}

.card {
  background-color: #fff;
  margin-top: 10px;
  padding: 20px 20px;

  .card-tit {
    color: #000;
    margin: 0px 0 20px;
  }
}
</style>
